import { createFileRoute } from '@tanstack/react-router';
import { ActivitiesTable } from '../../../../features/customer/activities/table';
import { getActivitiesOptions } from '../../../../features/customer/activities/queryOptions';
import { validateSearch } from '../../../../utils/pagination';

export const Route = createFileRoute(
  '/_authenticated/customers/$guid/_layout/activities',
)({
  component: Page,
  loaderDeps: ({ search: { page } }) => ({ page }),
  loader: ({ context: { queryClient }, deps: { page }, params: { guid } }) =>
    queryClient.ensureQueryData(getActivitiesOptions(guid, { page })),
  validateSearch: validateSearch,
});

function Page() {
  const data = Route.useLoaderData();

  return (
    <div className="col-span-full flex items-center justify-between">
      <ActivitiesTable activities={data} />
    </div>
  );
}
